import type { EntityTrack } from "../types/stageTypes";

/**
 * DEAL-BASED TRACKS (2026-10-25). A track is kept per lead (the default) or
 * per deal. Every write on a deal-based track names the deal it is on; a
 * lead-based track never sends one, so its requests are byte-for-byte what
 * they always were. A track from an older server has no `grain` = lead.
 */
export function isDealTrack(track?: Pick<EntityTrack, "grain"> | null): boolean {
  return track?.grain === "deal";
}

/** The `childId` to send with a write on this track, or undefined. */
export function trackWriteDealId(
  track?: Pick<EntityTrack, "grain" | "scope"> | null,
): number | undefined {
  if (!isDealTrack(track)) return undefined;
  const id = track?.scope?.childId;
  return id != null ? Number(id) : undefined;
}

/**
 * Does a track follow-up row belong to the slot this track row shows? A
 * deal-based track shows its open deal's rows; a lead-based one the lead's
 * (rows without a deal).
 */
export function followUpInTrackSlot(
  track: Pick<EntityTrack, "id" | "grain" | "scope">,
  row: { track: { id: number }; child?: { id: number } | null },
): boolean {
  if (row.track.id !== track.id) return false;
  const rowDeal = row.child?.id ?? null;
  if (!isDealTrack(track)) return rowDeal == null;
  return rowDeal != null && rowDeal === (track.scope?.childId ?? null);
}
